// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__W5t_v","main":"styles_main__10zv0","slideInSearchBar":"styles_slideInSearchBar__a4izo"};